import { createApp } from 'vue'
import Play from './Play.vue'
import 'material-icons/iconfont/round.css'
import '../../assets/style.css'

createApp(Play)
  .mount('#app')
